import React, { CSSProperties } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { updateErrorMsg } from 'reducers/user';

import GameModal, { btnRowStyle, primaryBtnStyle } from 'components/GameModal/GameModal';

// Mounted once at the app level (App.tsx). Visibility is driven by the redux
// `errorMsg.open` flag — NOT a context flag — so it shows regardless of view,
// including multi-table grid (each cell has its own GlobalProvider, which the
// old context-scoped flag couldn't reach from the app-level socket handler).
//
// Built on the shared branded GameModal (dark navy + gold) like the other
// system alerts — same shape as MaximumTablesReachedAlert: no X, and OK is the
// prominent way to acknowledge it. Tapping outside also dismisses (EN-10789):
// `dismiss` only clears the redux flag, exactly as OK does, so there is nothing
// to lose by closing it that way.
const ErrorMsgModal = () => {
  const dispatch = useAppDispatch();
  const errorMsg = useAppSelector((state) => state.user.errorMsg);

  const dismiss = () => {
    // Clear the title too so a later generic error doesn't inherit a stale
    // informational heading (e.g. "Buy-in").
    dispatch(updateErrorMsg({ open: false, title: '' }));
  };

  // Informational callers (e.g. a seat-taken buy-in) supply their own heading;
  // fall back to the generic error heading otherwise.
  const title = (errorMsg as any).title || 'Encountered an error!';

  return (
    <GameModal open={!!(errorMsg as any).open} onClose={dismiss} title={title} showClose={false}>
      <div style={messageStyle}>{errorMsg.msg}</div>
      <div style={btnRowStyle}>
        {/* No aria-label: the visible "OK" is already the accessible name, and
            adding one would override it with a test-hook string. */}
        <button onClick={dismiss} style={primaryBtnStyle}>
          OK
        </button>
      </div>
    </GameModal>
  );
};

export default ErrorMsgModal;

const messageStyle: CSSProperties = {
  fontSize: '0.95rem',
  color: 'rgba(255, 255, 255, 0.7)',
  lineHeight: 1.5,
  textAlign: 'center',
  marginBottom: '0.5rem'
};
